module.exports = __webpack_public_path__ + "img/purchases.908344c0.svg";